type FetcherRequestOptions = {
  headers?: Record<string, string>;
  cache?: RequestInit['cache'];
  next?: {
    revalidate?: number;
    tags?: string[];
  };
};

export const fetcher = {
  get: async <QueryParams extends Record<string, string> | undefined = Record<string, string>>(
    url: string | URL,
    params?: QueryParams | string,
    options?: FetcherRequestOptions,
  ): Promise<Response> => {
    const builtUrl = new URL(url);

    if (params && typeof params !== 'string') {
      Object.keys(params).forEach((key) => {
        if (params[key] === undefined) {
          return;
        }
        builtUrl.searchParams.append(key, (params as Record<string, string>)[key]);
      });
    }

    if (params && typeof params === 'string') {
      builtUrl.search = params;
    }
    const response = await fetch(decodeURIComponent(builtUrl.toString()), {
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      cache: options?.next ? undefined : options?.cache || 'no-store',
      next: options?.next,
    });

    return response;
  },
  post: async (url: string | URL, data: any, options?: FetcherRequestOptions): Promise<Response> => {
    const isFormData = data instanceof FormData;

    const response = await fetch(url, {
      method: 'POST',
      headers: isFormData
        ? {
            ...options?.headers,
          }
        : {
            'Content-Type': 'application/json',
            ...options?.headers,
          },
      body: isFormData ? data : JSON.stringify(data),
    });

    return response;
  },
  put: async (url: string | URL, data: any, options?: FetcherRequestOptions): Promise<Response> => {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Environment': 'online',
        ...options?.headers,
      },
      body: JSON.stringify(data),
    });

    return response;
  },
  delete: async (url: string | URL, options?: FetcherRequestOptions): Promise<Response> => {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Environment': 'online',
        ...options?.headers,
      },
    });
    return response;
  },
};
